import { render, staticRenderFns } from "./LockerReturnFail.vue?vue&type=template&id=6b439b4a&scoped=true&"
import script from "./LockerReturnFail.vue?vue&type=script&lang=js&"
export * from "./LockerReturnFail.vue?vue&type=script&lang=js&"
import style0 from "./LockerReturnFail.vue?vue&type=style&index=0&id=6b439b4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b439b4a",
  null
  
)

export default component.exports